import React from 'react';
import '../ImageManagementTask.scss';
import { FilterPanel } from './FilterPanel';

interface Props {
  setSelectedTab: React.Dispatch<React.SetStateAction<string>>;
}

const Filters = (props: Props) => {
  return (
    <div id="imt-filter" className="flex flex-column h-[100%] w-full">
      <div id="imt-filter-container" className="row h-[96%] w-full">
        <FilterPanel />
      </div>
    </div>
  );
};

export default Filters;
